const useMapQueries = () => {
  const queryFeatureLayer = async ({ layer, geometry, distance = 15 }) => {
    const query = layer.createQuery();
    query.geometry = geometry;
    query.distance = distance;
    query.units = "feet";
    const values = await layer.queryFeatures(query).then(
      function (response) {
        const stats = response?.features[0]?.attributes;
        return stats;
      },
      function (e) {
        console.error(e);
      }
    );
    return values;
  };

  const queryNearbyFeatures = async ({ geometry, featureLayers, distance }) => {
    const nearbyFeatures = await Promise.all([
      queryFeatureLayer({
        layer: featureLayers.polesLayer,
        geometry,
        distance,
      }),
      queryFeatureLayer({
        layer: featureLayers.structureLayer,
        geometry,
        distance,
      }),
      queryFeatureLayer({
        layer: featureLayers.spliceClosureLayer,
        geometry,
        distance,
      }),
    ]);
    return nearbyFeatures;
  };

  // Queries a photo point based off of a feature's threegisid.
  const queryPhotoPointByID = (photoPointLayer, threegisid) => {
    return new Promise((resolve) => {
      try {
        let query = photoPointLayer.createQuery();
        query.where = `THREEGISID = '${threegisid}'`;
        query.outFields = ["*"];

        photoPointLayer.queryFeatures(query).then(function (response) {
          resolve(
            response?.features[0]?.attributes
              ? response?.features[0]?.attributes
              : null
          );
        });
      } catch {
        resolve(null);
      }
    });
  };

  /* 
    Query for the nearest structure, pole, and splice closure, returning an accountcode.
    This value is used to filter the photo points layers for users assigned to filter
    AD groups.
  */
  const getClosestFeatures = async ({ geometry, featureLayers, distance }) => {
    let nearbyFeatures = await queryNearbyFeatures({
      geometry,
      featureLayers,
      distance,
    });
    let accountcode = nearbyFeatures[0]?.ACCOUNTCODE
      ? nearbyFeatures[0].ACCOUNTCODE
      : nearbyFeatures[1]?.ACCOUNTCODE
      ? nearbyFeatures[1].ACCOUNTCODE
      : nearbyFeatures[2]?.ACCOUNTCODE
      ? nearbyFeatures[2].ACCOUNTCODE
      : null;
    return accountcode;
  };

  const getNearbyFeatures = async (geometry, featureLayers) => {
    let nearbyFeatures = await queryNearbyFeatures({ geometry, featureLayers });
    return !(
      nearbyFeatures[0] == null &&
      nearbyFeatures[1] == null &&
      nearbyFeatures[2] == null
    );
  };

  return {
    getClosestFeatures,
    queryFeatureLayer,
    queryPhotoPointByID,
    getNearbyFeatures,
  };
};

export default useMapQueries;
